import { Pipe, PipeTransform } from '@angular/core';
import { highlightHtmlTextNodes, sanitizeHtml } from 'src/app/common/_helpers/html-sanitizer.util';

@Pipe({
  name: 'highlightSearch'
})
export class HighlightSearchPipe implements PipeTransform {
  transform(value: string | undefined | null, args: string): string {
    if (!value) return '';
    if (!args || args.trim() === '') {
      return sanitizeHtml(value);
    }

    // Split search query into individual tokens
    const searchTokens = args.trim().split(/\s+/).filter(t => t.length > 0);
    if (searchTokens.length === 0) return sanitizeHtml(value);

    return highlightHtmlTextNodes(value, searchTokens, 'span', 'search-highlight');
  }
}
